export const cachedEntities = ["InsurranceConvention"];
